import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Flag = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M16 6c-0.232 0-0.464 0.078-0.65 0.233l-6 4.973c-0.223 0.184-0.35 0.452-0.35 0.734v13.093c0 0.534 0.447 0.967 1 0.967h12c0.552 0 1-0.433 1-0.967v-13.093c0-0.282-0.128-0.55-0.35-0.734l-6-4.973c-0.187-0.155-0.42-0.233-0.65-0.233zM16 8.31l4.986 4.132v11.544h-9.972v-11.544l4.986-4.132z" />
    <path d="M14.5 13.542c0-0.828 0.67-1.5 1.5-1.5 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.83 0-1.5-0.672-1.5-1.5z" />
  </SvgIcon>
);

export default Flag;
